<div class="modal-header">
    <h4 tabindex="0" ngbAutofocus class="modal-title">
        Select Seat Type
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <div class="mb-4">This class offers two different types of seats.  Select the seat type you would prefer for your enrollment.</div>
    <div class="d-flex">
        <div class="col-3"><label class="label" for="seat">Seat Type</label></div>
        <div>
            <select id="seat" [(ngModel)]="seat">
                <option value="Primary">In-Person</option>
                <option value="Secondary">Virtual</option>
            </select>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="activeModal.close(seat)" [disabled]="!seat">Add Class</button>
</div>
